const permissions = {
    financing: {
        meta: "financing",
        product: {
            meta: "product",
            add: "add",
            update: "update",
            show: {
                meta: "show",
                amount: "amount",
                index: "index",
                fund: "fund",
                positionRecord: "positionR",
                chart: "chart"
            },
            warning: {
                meta: "warning",
                show: "show",
                setting: {
                    meta: "setting",
                    add: {
                        meta: "add",
                        rule: "rule"
                    },
                    remove: "remove"
                }
            },
            addPositionRecord: "addPR"
        }
    }
};

const buildPermission = (permissionTree, prefix) => {
    let meta = permissionTree.meta;
    if (meta) {
        permissionTree.meta = prefix + meta;
        prefix = permissionTree.meta + ".";
    }
    for (let permissionName in permissionTree) {
        if (permissionName == "meta") {
            continue;
        }
        if (typeof permissionTree[permissionName] == "object") {
            buildPermission(permissionTree[permissionName], prefix);
            continue;
        }
        permissionTree[permissionName] = prefix + permissionTree[permissionName];
    }
};

buildPermission(permissions, "");

export default permissions;